import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text, TextProps} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledEventProjectAccessesCountersItem = styled(Text)<TextProps>(
    ({theme: {typography, spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        ${typography.textSm};
        & > span {
            white-space: nowrap;
        }
    `
)

export const StyledEventProjectAccessesCountersValue = styled.span(
    ({theme: {spacing, palette}}) => css`
        padding: ${spacing * 0.5}px ${spacing * 1}px;
        min-width: 24px;
        border-radius: 4px;
        text-align: center;
        border: 1px solid ${palette.neutral[200]};
        font-weight: 500;
        line-height: 14px;
    `
)

export const StyledAgendaEventAccessInfo = styled(Flexbox)`
    flex-wrap: wrap;
`

export const StyledMissedAccessesWrapper = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 2.5}px 0;
    `
)

export const StyledWarningAccessesReached = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        background-color: ${palette.orange['100']};
        padding: ${spacing * 2}px;
        border-radius: 8px;

        & b {
            font-weight: 500;
        }

        & svg {
            width: 14px;
            height: 14px;
            color: ${palette.orange['500']};
        }
    `
)
